import {injectable} from "tsyringe";
import {DeleteEmployeeCommand} from "../commands/delete-employee.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {Employee} from "../domain/entities/employee.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({source: DeleteEmployeeCommand, target: `dto`})
export class DeleteEmployeeCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Employee> {

    protected async toDTO(employee: Employee): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{uid: employee.uid});
    }

}
